import React from "react";
import { Card, Input, Grid, Button, Popup } from "semantic-ui-react";
import { Col, Row, Label, CardBody } from "reactstrap";
import { Icon } from "semantic-ui-react";
import { IncotermsInfo } from "./data";
import { saveAs } from "file-saver";
import axios from 'axios';
import donwload from "../../../../../resources/donwload.png";
import { withNamespaces } from "react-i18next";
import info from "./info.png"
import "../../style.scss";

function Incoterms(props) {
  console.log("--->", props);
  let [valueGrupoC, setValueGrupoC] = React.useState("cfr");
  let [valueGrupoD, setValueGrupoD] = React.useState("dpu");
  let [valueGrupoF, setValueGrupoF] = React.useState("fca");
  let [activeGC, setActiveGC] = React.useState("cfr");
  let [activeGD, setActiveGD] = React.useState("dpu");
  let [activeGF, setActiveGF] = React.useState("fca");
  let [loading, setloading] = React.useState(false);

  function handleClickGC(inpt) {
    setValueGrupoC(inpt);
    setActiveGC(inpt);
  }

  function handleClickGD(inpt) {
    setValueGrupoD(inpt);
    setActiveGD(inpt);
  }

  function handleClickGF(inpt) {
    setValueGrupoF(inpt);
    setActiveGF(inpt);
  }
  function sleep(milliseconds) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  function descarga(uri) {
    const linkSource = props.t("icoterm_dowloand_pdf");

    axios({
      method: 'get',
      url: encodeURI(linkSource),
      responseType: 'blob'
    }).then(function (response) {
      saveAs(
        response.data,
        'Incoterms'
      );
      setloading(false)
    }).catch(function (error) {
      console.log('download error');
    });
  };


  return (
    <>
      <div className="">
        <div className="col-12 divcenter">
          <img
            src={
              props.t('icoterm_img')
            }
            alt=""
            width={"90%"}
            height={"90%"}
          />
        </div>
        <div style={{ textAlign: "end" }} className="col-12">
          {loading ? (

            <Icon
              loading={loading}
              style={{ marginTop: "9px" }}
              name="circle notch"
              size="large"
            />
          ) : (
            <img
              onClick={() => {
                setloading(true)
                sleep(1000).then(() => {
                  descarga()
                });
              }}
              style={{ margin: "-1px 24px 6px", marginTop: "-1px", cursor: "pointer" }}
              alt=""
              src={"https://magiclog.blob.core.windows.net/europartnerspic/pdficon.png"}
              width="35"
              title={props.t("download_pdf")}
              height="35"
            ></img>
          )}
        </div>
      </div>

      <br />

      {/* <div className="row"> */}
      <CardBody>
        <div className="row">
          {/* <div className="row"> */}
          <div className="col-xs-12 col-md-6 col-lg-6 pb-5">
            <div className="row d-flex align-items-center">
              <span>{props.t("group_c_indirect")}</span>
              <Popup
                content={props.t(IncotermsInfo.grupoC.grupoData)}
                style={{ textAlign: "justify", color: "#000a2e" }}
                position="right center"
                wide="very"
                trigger={
                  <span className="icon-informative-tooltip custom-icon-tooltip" />
                  // <img
                  //   style={{
                  //     marginLeft: "5px",
                  //     width: "15px",
                  //     height: "15px",
                  //     marginTop: "2px"
                  //   }}

                  //   alt=""
                  //   src={info}

                  // ></img>
                }
              />
            </div>
            <br></br>
            <div className="row">
              <div className="col-xs-3 col-md-2 col-lg-2" style={{ padding: "0" }}>
                <Button
                  active={activeGC === "cfr"}
                  className="BUTTON UI REACT STRAP BORDER"
                  onClick={() => {
                    handleClickGC("cfr");
                  }}
                  basic
                  fluid
                  compact
                  size="tiny"
                >
                  CFR
                </Button>
                <Button
                  active={activeGC === "cif"}
                  className="BUTTON UI REACT STRAP BORDER"
                  onClick={() => {
                    handleClickGC("cif");
                  }}
                  basic
                  fluid
                  compact
                  size="tiny"
                >
                  CIF
                </Button>
                <Button
                  active={activeGC === "cpt"}
                  className="BUTTON UI REACT STRAP BORDER"
                  onClick={() => {
                    handleClickGC("cpt");
                  }}
                  basic
                  fluid
                  compact
                  size="tiny"
                >
                  CPT
                </Button>
                <Button
                  active={activeGC === "cip"}
                  className="BUTTON UI REACT STRAP BORDER"
                  onClick={() => {
                    handleClickGC("cip");
                  }}
                  basic
                  fluid
                  compact
                  size="tiny"
                >
                  CIP
                </Button>
              </div>
              <div className="col-xs-9 col-md-10 col-lg-10" style={{ paddingLeft: "0" }}>
                <Card
                  Card
                  fluid
                  header={
                    <div className="euro-title-form mb-2">
                      {props.t(IncotermsInfo.grupoC[valueGrupoC].title)}
                    </div>
                  }
                  description={props.t(IncotermsInfo.grupoC[valueGrupoC].data)}
                  className="CARD UI REACT STRAP BORDER"
                ></Card>
              </div>
            </div>
          </div>

          <div className="col-xs-12 col-md-6 col-lg-6 pb-5">
            <div className="row d-flex align-items-center">
              <span>{props.t("group_d_direct")}</span>
              <Popup
                content={props.t(IncotermsInfo.grupoD.grupoData)}
                style={{ textAlign: "justify", color: "#000a2e" }}
                position="top center"
                wide="very"
                trigger={
                  <span className="icon-informative-tooltip custom-icon-tooltip" />
                  // <img
                  //   style={{
                  //     marginLeft: "5px",
                  //     width: "15px",
                  //     height: "15px",
                  //     marginTop: "2px"
                  //   }}

                  //   alt=""
                  //   src={info}

                  // ></img>
                }
              />
            </div>
            <br />
            <div className="row">
              <div className="col-xs-3 col-md-2 col-lg-2" style={{ padding: "0" }}>
                <Button
                  active={activeGD === "dpu"}
                  className="BUTTON UI REACT STRAP BORDER"
                  onClick={() => {
                    handleClickGD("dpu");
                  }}
                  basic
                  fluid
                  compact
                  size="tiny"
                >
                  DPU
                </Button>
                <Button
                  active={activeGD === "dap"}
                  className="BUTTON UI REACT STRAP BORDER"
                  onClick={() => {
                    handleClickGD("dap");
                  }}
                  basic
                  fluid
                  compact
                  size="tiny"
                >
                  DAP
                </Button>
                <Button
                  active={activeGD === "ddp"}
                  className="BUTTON UI REACT STRAP BORDER"
                  onClick={() => {
                    handleClickGD("ddp");
                  }}
                  basic
                  fluid
                  compact
                  size="tiny"
                >
                  DDP
                </Button>
              </div>
              <div className="col-xs-9 col-md-10 col-lg-10" style={{ paddingLeft: "0" }}>
                <Card
                  Card
                  fluid
                  header={
                    <div className="euro-title-form mb-2">
                      {props.t(IncotermsInfo.grupoD[valueGrupoD].title)}
                    </div>
                  }
                  description={props.t(IncotermsInfo.grupoD[valueGrupoD].data)}
                  className="CARD UI REACT STRAP BORDER"
                />
              </div>
            </div>
          </div>

          <div className="col-xs-12 col-md-6 col-lg-6 pb-5">
            <div className="row d-flex align-items-center">
              <span>{props.t("group_e_selling")}</span>
              <Popup
                content={props.t(IncotermsInfo.grupoE.grupoData)}
                style={{ textAlign: "justify", color: "#000a2e" }}
                position="top center"
                wide="very"
                trigger={
                  <span className="icon-informative-tooltip custom-icon-tooltip" />
                  // <img
                  //   style={{
                  //     marginLeft: "5px",
                  //     width: "15px",
                  //     height: "15px",
                  //     marginTop: "2px"
                  //   }}

                  //   alt=""
                  //   src={info}

                  // ></img>
                }
              />
            </div>
            <br />
            <div className="row">
              <div className="col-xs-3 col-md-2 col-lg-2" style={{ padding: "0" }}>
                <Button
                  active={true}
                  className="BUTTON UI REACT STRAP BORDER"
                  basic
                  fluid
                  compact
                  size="tiny"
                >
                  EXW
                </Button>
              </div>
              <div className="col-xs-9 col-md-10 col-lg-10" style={{ paddingLeft: "0" }}>
                <Card
                  Card
                  fluid
                  header={
                    <div className="euro-title-form mb-2">
                      {props.t(IncotermsInfo.grupoE.exw.title)}
                    </div>
                  }
                  description={props.t(IncotermsInfo.grupoE.exw.data)}
                  className="CARD UI REACT STRAP BORDER"
                />
              </div>
            </div>
          </div>

          <div className="col-xs-12 col-md-6 col-lg-6 pb-5">
            <div className="row align-items-center">
              <span>{props.t("group_f_indirect")}</span>
              <Popup
                content={props.t(IncotermsInfo.grupoF.grupoData)}
                style={{ textAlign: "justify", color: "#000a2e" }}
                position="top center"
                wide="very"
                trigger={
                  <span className="icon-informative-tooltip custom-icon-tooltip" />
                  // <img
                  //   style={{
                  //     marginLeft: "5px",
                  //     width: "15px",
                  //     height: "15px",
                  //     marginTop: "2px"
                  //   }}

                  //   alt=""
                  //   src={info}

                  // ></img>
                }
              />
            </div>
            <br />
            <div className="row">
              <div className="col-xs-3 col-md-2 col-lg-2" style={{ padding: "0" }}>
                <Button
                  active={activeGF === "fca"}
                  className="BUTTON UI REACT STRAP BORDER"
                  onClick={() => {
                    handleClickGF("fca");
                  }}
                  basic
                  fluid
                  compact
                  size="tiny"
                >
                  FCA
                </Button>
                <Button
                  active={activeGF === "fas"}
                  className="BUTTON UI REACT STRAP BORDER"
                  onClick={() => {
                    handleClickGF("fas");
                  }}
                  basic
                  fluid
                  compact
                  size="tiny"
                >
                  FAS
                </Button>
                <Button
                  active={activeGF === "fob"}
                  className="BUTTON UI REACT STRAP BORDER"
                  onClick={() => {
                    handleClickGF("fob");
                  }}
                  basic
                  fluid
                  compact
                  size="tiny"
                >
                  FOB
                </Button>
              </div>
              <div className="col-xs-9 col-md-10 col-lg-10" style={{ paddingLeft: "0" }}>
                <Card
                  // style={{ height: "220px" }}
                  Card
                  fluid
                  header={
                    <div className="euro-title-form mb-2">
                      {props.t(IncotermsInfo.grupoF[valueGrupoF].title)}
                    </div>
                  }
                  description={props.t(IncotermsInfo.grupoF[valueGrupoF].data)}
                  className="CARD UI REACT STRAP BORDER"
                />
              </div>
            </div>
          </div>
          {/* </div> */}
        </div>
      </CardBody>
      {/* </div> */}
    </>
  );
}

export default withNamespaces()(Incoterms);
